module.exports = __webpack_public_path__ + "static/media/new-whole-icon.3718bebf.svg";